import {AlertComponent} from './alert.component';
import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {ReactiveFormsModule} from '@angular/forms';
import {AlertService} from '../../service/alert.service';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    imports: [BrowserModule, ReactiveFormsModule, NgbModule],
    exports: [AlertComponent],
    declarations: [AlertComponent],
    providers: [AlertService],
})

export class AlertModule
{
}